import React from "react";
import PropTypes from "prop-types";
import { ContainerBody } from "./styled";
import { Navbar, Footer } from "../../../components";
function BlogLayout({ children }) {
  return (
    <ContainerBody>
      <Navbar />
      {children}
      <Footer />
    </ContainerBody>
  );
}

BlogLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default BlogLayout;
